{
  "register-success-page": {
    "buttons": {
      "start": "Let's start"
    },
    "text": {
      "account-created": "Account created",
      "account-created-hint": "Your account is created! You can now log in and enjoy our booking system"
    }
  }
}
